<template>
  <div class="code-release-flow-add">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请代码发布</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Form inline :label-width="100" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="版本号" style="width: 100%" prop="version">
                <Input :maxlength="100" v-model="baseInfo.version" placeholder="请填写版本号"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
          <Col span="24">
              <FormItem label="优先级" style="width: 100%" prop="priority">
                <RadioGroup v-model="baseInfo.priority" type="button">
                  <Radio :label="0">普通</Radio>
                  <Radio :label="1">紧急</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="24">
              <FormItem label="发布类型" style="width: 100%" prop="type">
                <CheckboxGroup v-model="baseInfo.type" @on-change="onSelectPm">
                  <Checkbox :label="0">Bug修复</Checkbox>
                  <Checkbox :label="1">功能维护</Checkbox>
                  <Checkbox :label="2">新功能增加</Checkbox>
                  <Checkbox :label="3">代码优化</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row>
            <Col span="24">
              <FormItem label="发布模块" style="width: 100%" prop="module">
                <Select v-model="baseInfo.module" multiple placeholder="选择要发布的模块" filterable transfer clearable ref="releaseModules">
                  <Option v-for="item in moduleList" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
                 <Input v-model="baseInfo.module" type="textarea" :rows="4" placeholder="请填写发布模块" />
              </FormItem>
            </Col>
          </Row> -->
          <Row>
            <Col span="24">
              <FormItem label="发布内容" style="width: 100%" prop="describe">
                <vue-editor v-model="baseInfo.describe" ref="myQuillEditorBody" :editorOptions="editorOptionBody" class="code-release-add-content"></vue-editor>
              </FormItem>
            </Col>
          </Row>
          <!-- <Row>
            <Col span="24">
              <FormItem label="测试报告附件" style="width: 100%">
                 <Upload  :action="CodeReleaseFlowUploadEnclosureUrl"
                          :headers="uploadHeader"
                          :on-success="uploadEnclosureSuccess"
                          :on-error="uploadEnclosureError"
                          :on-format-error="uploadEnclosureFormatError"
                          :on-exceeded-size="uploadEnclosureExceededSize"
                          :show-upload-list="true"
                          :max-size="10240"
                          :format="['pdf', 'docx', 'xlsx']">
                      <Button icon="ios-cloud-upload-outline" size="small">点击上传</Button>
                    </Upload>
                    <Alert type="warning" show-icon>只能上传一个文件,上传多次以最后一次上传的文件为准</Alert>
              </FormItem>
            </Col>
          </Row> -->
           <Row>
            <Col span="24">
             <FormItem label="软件资产地址" style="width: 100%" prop="soft_asset_address" v-show="pm_visible">
                <Input :maxlength="500" v-model="baseInfo.soft_asset_address" :rows="6" placeholder="请填写软件资产地址" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="文档SVN地址" style="width: 100%" prop="test_report_address">
                <Input :maxlength="500" v-model="baseInfo.test_report_address" :rows="6" placeholder="请填写项目文档SVN地址" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="通知开发人员" prop="developer" style="width: 100%">
                <Select v-model="baseInfo.developer" placeholder="请选择要通知的开发人员" clearable filterable multiple>
                  <Option v-for="item in all_developer_list" :key="item.key" :value="item.key" :label="item.label"></Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="构建时间" style="width: 100%">
                   <Alert type="error">
                      <!-- <i-switch v-model="isNow" @on-change="switchChange">
                          <span slot="open">是</span>
                          <span slot="close">否</span>
                      </i-switch> -->
                     <DatePicker type="datetime" v-model="baseInfo.custom_build_time" :options="options3" :time-picker-options="options4" @on-change="handleChange" format="yyyy-MM-dd HH:mm" placeholder="请选择构建时间" style="width: 200px"></DatePicker>
                     <span>系统会按照您选择的时间构建生产环境，为空则表示立即构建</span>
                  </Alert>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="产品经理" prop="pm" style="width: 100%" v-show="pm_visible">
                <Select v-model="baseInfo.pm" placeholder="请选择此次发布版本对应的产品经理" clearable filterable>
                  <Option v-for="item in all_user_list" :key="item.key" :value="item.key" :label="item.label"></Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
           <Row>
            <Col span="24">
              <FormItem
                  v-for="(item, index) in baseInfo.steps"
                  :key="index"
                  :label="item.name"
                  :prop="'steps.' + index + '.users_sel'"
                  :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
              <i-select v-model="item.users_sel" filterable  multiple>
                <i-option v-for="user in item.users" :value="user.username" :key="user.id" :label="user.name"></i-option>
              </i-select>
            </FormItem>
          </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createCodeReleaseFlow, CodeReleaseFlowUploadEnclosureUrl, getTenantReleaseSteps } from '@/api/workflow/code_release_flow'
import { getModuleAllList } from '@/api/workflow/project'
import GeneralAlert from '../components/general-alert'
import { forEach } from '@/libs/tools'
import { getTenantRolesUser } from '@/api/workflow/tenant'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'edit',
  components: {
    GeneralAlert,
    VueEditor
  },
  data () {
    const validatePm = (rule, value, callback) => {
      if (!value && this.pm_visible) {
        callback(new Error('请选择产品经理 !'))
      } else {
        callback()
      }
    }
    const validateSoft = (rule, value, callback) => {
      if (!value && this.pm_visible) {
        callback(new Error('请填写软件资产地址 !'))
      } else {
        callback()
      }
    }
    return {
      options3: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      options4: {
        'disabled-hours': this.getTimeArray(new Date().getHours()),
        'disabled-minutes': this.getTimeArray(new Date().getMinutes())
      },
      isNow: false,
      all_developer_list: [],
      pm_visible: false,
      all_user_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      CodeReleaseFlowUploadEnclosureUrl: CodeReleaseFlowUploadEnclosureUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        custom_build_time: null,
        title: '',
        describe: '',
        module: [],
        version: '',
        priority: 0,
        type: [],
        enclosure: '',
        test_report_address: '',
        soft_asset_address: '',
        pm: '',
        developer: [],
        steps: [
          {
            id: null,
            name: null,
            users: [],
            users_sel: []
          }
        ]
      },
      version: {},
      baseInfoFormRules: {
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        version: { required: true, message: '版本号不能为空', trigger: 'blur' },
        priority: { required: true, message: '请选择优先级', trigger: 'blur', type: 'number' },
        // module: { required: true, message: '请选择要发布的模块', type: 'array' },
        // module: { required: true, message: '请填写要发布的模块', trigger: 'blur' },
        pm: [
          { required: true, validator: validatePm, trigger: 'change', type: 'number' }
        ],
        type: { required: true, message: '请选择发布类型', type: 'array' },
        describe: { required: true, message: '发布内容不能为空', trigger: 'blur' },
        test_report_address: { required: true, message: '项目文档SVN地址不能为空', trigger: 'blur' },
        soft_asset_address: { required: true, validator: validateSoft, trigger: 'blur' }
      },
      moduleList: [],
      submitting: false
    }
  },
  mounted: function () {
    // this.getModuleList()
    this.fetchStepsData()
    this.getAllUsersData()
    this.getAllDevelopUsersData()
    // this.getModuleReleaseProcessData(this.$store.state.user.defaultTenant)
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.fetchStepsData()
      // this.getModuleReleaseProcessData(this.$store.state.user.defaultTenant)
    }
  },
  methods: {
    handleChange (date) {
      if (new Date(date).getHours() > new Date().getHours()) {
        this.options4['disabled-minutes'] = []
      } else {
        this.options4['disabled-minutes'] = this.getTimeArray(new Date().getMinutes())
      }
    },
    getTimeArray (num) {
      let array = []
      for (let i = 0; i < num; i++) {
        array.push(i)
      }
      return array
    },
    switchChange () {
      if (this.isNow) {
        this.baseInfo.custom_build_time = null
      }
    },
    // 审批流程
    getModuleReleaseProcessData (id) {
      getTenantRolesUser(id).then(res => {
        let result = res.data.developers
        for (let i in result) {
          this.all_developer_list.push({ key: result[i].id, label: result[i].name })
        }
      }).catch(res => {
        console.log(res.response)
        this.$Notice.error({ title: '获取数据失败' })
      })
    },
    onSelectPm (value) {
      console.log(value)
      if (value.indexOf(1) > -1 || value.indexOf(2) > -1) {
        this.pm_visible = true
      } else {
        this.pm_visible = false
      }
      this.initPm(this.pm_visible)
      this.fetchStepsData()
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有用户列表
    getAllDevelopUsersData () {
      this.all_developer_list = []
      let params = {}
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_developer_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有产品组用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': '产品组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    fetchStepsData () {
      this.baseInfo.steps = []
      let data = {
        type: this.baseInfo.type
      }
      getTenantReleaseSteps(data).then(res => {
        if (res.data.data instanceof Array && res.data.data.length > 0) {
          this.baseInfo.steps = res.data.data
          // 给pmo审批步骤赋值所有人
          this.baseInfo.steps.map(item => {
            if (item.name === 'PMO审批') {
              item.users_sel = item.users.map(q => q.username)
            }
          })
        }
      })
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        this.baseInfo.enclosure = res
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 获取模块列表
    getModuleList () {
      this.$refs.releaseModules.clearSingleSelect()
      getModuleAllList({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    // 提交
    submit () {
      // 判断如果不是立即发布,必须选择发布时间
      // if (!this.isNow) {
      //   if (!this.baseInfo.custom_build_time) {
      //     this.$Message['error']({
      //       background: true,
      //       content: '请选择构建时间,如果是立即发布请把 是否立即发布 选择是',
      //       duration: 5
      //     })
      //     return
      //   }
      // } else {
      //   this.baseInfo.custom_build_time = null
      // }
      if (!this.baseInfo.custom_build_time) {
        this.baseInfo.custom_build_time = null
      }
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          forEach(this.baseInfo.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            if (item.users_sel instanceof Array) {
              this.baseInfo[stepName] = item.users_sel
            }
          })
          this.submitting = true
          createCodeReleaseFlow(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'codeReleaseFlowDetail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .code-release-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
